import React from "react";
import "./Alert.css";

// NR*****
// Cursor added this to ds2 without asking me, this is not a supported core component

export type AlertProps = {
  variant?: "default" | "destructive" | "warning" | "success";
  className?: string;
  children?: React.ReactNode;
};

export const Alert = ({
  variant = "default",
  className = "",
  children,
  ...props
}: AlertProps & React.ComponentPropsWithoutRef<"div">) => {
  
  const getVariantClass = () => {
    switch (variant) {
      case "default":
        return "ds2-alert-default";
      case "destructive":
        return "ds2-alert-destructive";
      case "warning":
        return "ds2-alert-warning";
      case "success":
        return "ds2-alert-success";
      default:
        return "ds2-alert-default";
    }
  };

  return (
    <div 
      className={`ds2-alert ${getVariantClass()} ${className}`}
      role="alert"
      {...props}
    >
      {children}
    </div>
  );
};

export type AlertDescriptionProps = {
  className?: string;
  children?: React.ReactNode;
};

export const AlertDescription = ({
  className = "",
  children,
  ...props
}: AlertDescriptionProps & React.ComponentPropsWithoutRef<"div">) => {
  return (
    <div 
      className={`ds2-alert-description ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};